import { SET_BRUSH_TIMESTAMPS } from '../../../../../actions/chart';

export default (state = null, action) => {
  switch (action.type) {
    case SET_BRUSH_TIMESTAMPS:
      return action.payload.endTimestamp;
    default:
      return state;
  }
};

export const getEndTimestamp = state => state;